var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 45,
    viewBox: "0 0 52 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0531 36.3668L5.2838 23.9493C4.07341 22.5537 2.11817 22.5537 0.907789 23.9493C-0.302596 25.3449 -0.302596 27.5994 0.907789 28.995L13.8806 43.9533C15.091 45.3489 17.0463 45.3489 18.2566 43.9533L51.0922 6.09244C52.3026 4.69682 52.3026 2.44235 51.0922 1.04672C49.8818 -0.348907 47.9266 -0.348907 46.7162 1.04672L16.0531 36.3668Z",
    fill: "#3C4977"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b652bdc16b195369ee5209450d0b0c21.svg";
export { ForwardRef as ReactComponent };